import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
class DateOption extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick(e){
        const {onClick} = this.props;
        onClick(e, {...this.props});
    }
    render() {
        const {block} = this.props;
        const startDt = moment(block.startDate);
        const endDt = moment(block.endDate);
        const diff = endDt.diff(startDt, 'days');
        return (
            <div className={`option ${block.selected ? 'selected' : ''}`} onClick={this.onClick}>
                <div>{block.name}</div>
                {diff === 0 ? <div>{`${startDt.format('L')}`}</div> :<div>{`${startDt.format('L')} - ${endDt.format('L')}`}</div>}
                
            </div>
        );
    }
}

DateOption.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default DateOption;